import { useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useIntegrations = () => {
  const { accountId } = useAccount();

  const storeKey = ['integrations', accountId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchIntegrations({ accountId }));

  const mappedIntegrations = useMemo(
    () => (data?.data || []).reduce((prev, integration) => ({ ...prev, [integration.integrationId]: integration }), {}),
    [data?.data]
  );

  return { isLoading, integrations: data?.data || [], mappedIntegrations };
};

export default useIntegrations;
